import { InjectionToken, Signal } from "@angular/core";
import { Observable } from "rxjs";

/**
 * A field whose value lives in the component instead of in a DOM input. Validators prefer this
 * over reading an <input>, so a field built from a <button> or a list (a picker) validates the
 * same way a text field does.
 */
export interface CerrixInputValueSource<T = unknown> {
    /**
     * The field's value. Null, an empty string or array, NaN and an invalid date mean nothing is
     * filled in. Signals compare by reference, so an array or date must be replaced, not mutated,
     * for a validator to see the change.
     */
    readonly validationValue: Signal<T>;

    /**
     * Emits when the user is done with the field, for a field whose value is picked elsewhere:
     * opening its dialog blurs it, which is the middle of the interaction and not the end.
     * Providing it means blurring the field no longer counts; left out, a blur does.
     */
    readonly validationTouched?: Observable<void>;
}

export const CERRIX_INPUT_VALUE_SOURCE = new InjectionToken<CerrixInputValueSource>(
    "CERRIX_INPUT_VALUE_SOURCE",
);
